import qs from 'qs'

import { getRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'
import { Feedbacks, UserFeedbackStatus } from '../../types/Feedback'
import { User } from '../../types/User'

type FeedbacksResponse = {
  data: {
    id: string
    documentId?: string
    rating: string
    text: string
    date: string
    user: {
      id: string | number
      firstName: string
      lastName: string
    }
  }[]
  total: number
  userFeedback?: {
    id: string
    rating: string
    text: string
    date: string
    status: UserFeedbackStatus
  } | null
}

export type FeedbacksParams = {
  id: string
  limit: number
  offset: number
}

const feedbacks = ({ id, limit, offset }: FeedbacksParams) =>
  getRestRequest({
    url:
      api.REST_API_URL +
      `/feedbacks/offer/${id}?${qs.stringify({
        limit,
        offset,
      })}`,
    transformer: (data: FeedbacksResponse): Feedbacks => {
      console.log('FEEDBACK RESPONSE INNER', data)
      return {
        data: data?.data?.map((d) => ({
          ...d,
          id: String(d.id),
          user: d?.user
            ? ({ ...d.user, id: String(d.user.id) } as User)
            : undefined,
        })),
        total: data?.total,
        userFeedback: data?.userFeedback ?? null,
      }
    },
  })

export default feedbacks
